export const POPPINS      = { fontFamily: "'Poppins', sans-serif" };
export const HEADER_COLOR = "#1B2559";
export const PRIMARY      = "#1976d2";

export const fmtDate  = (v) => { if (!v) return "—"; try { return new Date(v).toLocaleString();    } catch { return v; } };
export const fmtShort = (v) => { if (!v) return "—"; try { return new Date(v).toLocaleDateString(); } catch { return v; } };
